import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('issuer_period_audience', '/issuer_period_audiences')
const actions = generator.generate()

export default actions
